import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgGenderFemale({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8 1.4a4.22 4.22 0 01.75 8.38v1.07h1.59c.38 0 .69.28.74.65v.1c0 .41-.33.75-.74.75H8.75v1.7c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.75-.75v-1.7H5.57a.75.75 0 01-.74-.65v-.1c0-.41.33-.75.74-.75h1.68V9.78A4.22 4.22 0 013.8 5.83l-.01-.2A4.22 4.22 0 018 1.4zm0 1.5a2.72 2.72 0 100 5.44A2.72 2.72 0 008 2.9z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgGenderFemale.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgGenderFemale.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgGenderFemale svgRef={ref} {...props} />);
export default ForwardRef;
